import { Component, OnInit, ComponentRef, AfterViewChecked, Input } from '@angular/core';
import { IModalDialog, IModalDialogOptions, IModalDialogButton } from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-condition-privacy-modal',
  templateUrl: './alg-condition-privacy-modal.component.html',
  styleUrls: ['./alg-condition-privacy-modal.component.scss'],
})
export class AlgConditionPrivacyModalComponent implements OnInit, IModalDialog, AfterViewChecked {
  public description: string;
  private title: string;
  public placet;
  public modalN;
  public supplyType;
  public productFamily;
  public isVulnerable: boolean;
  actionButtons: IModalDialogButton[];
  constructor(private utils: UtilsService, private api: ApiService) {
    this.actionButtons = [
      {
        text: '',
        buttonClass: 'alg-btn-close',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
      {
        text: 'Ok',
        buttonClass: 'button-cancel-product',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];

    this.api.isUser75YearsOld$.subscribe((value) => {
      this.isVulnerable = value && this.supplyType !== 'LUCE';
    });
  }

  ngOnInit() {}

  _createId(title) {
    let id;
    switch (title) {
      case 'Informativa sui dati catastali':
        id = 'informativa-catastali';
        break;
      case 'Accettazione espressa di clausole':
        id = 'informativa-clausole';
        break;
      case 'Informativa contrattuale e consensi':
        id = 'informativa-consensi';
        break;
      default:
        id = 'modal';
        break;
    }
    return id;
  }

  ngAfterViewChecked() {
    const buttonClose = document.getElementsByClassName('button-cancel-product');
    const exitButton = document.getElementsByClassName('alg-btn-close');
    if (!buttonClose[0] || !exitButton[0]) return;
    const id = this._createId(this.title);
    buttonClose[0].setAttribute('id', id + '-close');
    buttonClose[0].setAttribute('type', 'button');
    exitButton[0].setAttribute('id', id + '-exit');
    exitButton[0].setAttribute('type', 'button');
  }

  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<any>>) {
    this.description = options.data.description;
    this.title = options.data.title;
    this.placet = options.data.placet;
    this.modalN = options.data.modalN;
    this.supplyType = options.data.supplyType;
    this.productFamily = options.data.productFamily;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-condition-privacy-modal/alg-condition-privacy-modal.component.ts